/** Approved JOS palette from the supplied Brand Style Guide, pages 5–7 and 13.
 * Translate the archived visual tokens, never its content or functionality.
 */
export function applyBrandPalette(css) {
  const colors = {
    '#080B14': '#231F20', '#101522': '#231F20', '#151B2B': '#231F20',
    '#141A28': '#231F20', '#1a1f2c': '#231F20',
    '#C9A646': '#00A499', '#E5C76B': '#00A499',
    '#B8BCC8': '#FAF8F5', '#D5D8E0': '#FAF8F5', '#fff': '#FAF8F5',
  };
  let branded = css.replace(/#[0-9a-f]{3,8}\b/gi, token => colors[token] || token);
  const rgb = {
    '201,166,70': '0,164,153', '184,188,200': '250,248,245',
    '255,255,255': '250,248,245', '8,11,20': '35,31,32',
    '21,27,43': '35,31,32', '12,16,28': '35,31,32', '0,0,0': '35,31,32',
  };
  Object.entries(rgb).forEach(([original, approved]) => {
    branded = branded.split(`rgba(${original},`).join(`rgba(${approved},`);
  });
  return branded
    .replaceAll("'Playfair Display'", "'Cormorant Garamond'")
    .replaceAll('%23B8BCC8', '%236B6768');
}

export function applyBrandSections(root) {
  root.dataset.brand = 'jos';
  ['jil-sec-consultation-194', 'jil-sec-practice-areas-196', 'jil-sec-process-197'].forEach(id => {
    root.querySelector(`#${id}`).classList.add('jos-brand-light');
  });
}